import Master from 'components/helper/Master'
import React from 'react'

function TechnologyMaster() {
  return (
    <Master name={{name:"Technology Master"}} getUrl={"/Admin/getAlltechnology"} deleteUrl={"/Admin/deletetechnology"} updateurl={"/Admin/Updatetechnology"}addurl={"/Admin/addtechnology"} id={'TechnologyId'}/>
  )
}

export default TechnologyMaster